export const en = {
    'freelancer-is-busy': 'busy',
    'freelancer-is-busy-is-owner': 'I am busy',
    'freelancer-is-cooperating': 'you are collaborating',
    'freelancer-is-free': 'available',
    'freelancer-is-free-is-owner': 'I am free'
};
